'use client';

import { useTranslations } from 'next-intl';
import { AppStoreLinks } from '@/components/app-upsells/app-store-links';
import { useUpsellImpression } from '@/components/app-upsells/use-upsell-impression';

// Marketing landing has no app chrome, so `AppFooter` never mounts (see
// `app-shell.tsx` simpleHeader path). This is the slim landing equivalent — the
// brand slogan over the copyright line. No `GUTTER_CLASS` here: the landing
// content already renders inside the gutter wrapper, whereas `AppFooter` mounts
// outside it.
export function LandingFooter(): React.ReactNode {
  const t = useTranslations('footer');
  const downloadRef = useUpsellImpression('landing', true, 'landing');

  return (
    <footer className="mt-8 flex flex-col items-center gap-2 border-solid border-t border-border-primary pt-6 text-center">
      <AppStoreLinks
        ref={downloadRef}
        surface="landing"
        entryPoint="landing"
        location="landing-footer"
        className="justify-center"
      />
      <p className="text-caption font-medium text-foreground-secondary">{t('slogan')}</p>
      <p className="text-micro text-foreground-tertiary">{t('copyright')}</p>
    </footer>
  );
}
